import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Spinner } from "react-bootstrap";
import { useHubCardLivePreview } from "src/hooks/useHubCardLivePreview";
import { mapHighHandDoc, isMeaningfulHighHandPage } from "src/utils/mapHighHand";
import { highHandLivePreviewRequestHandler } from "src/utils/highHandLivePreviewHandler";
import HighHandPageContent from "src/pages/promotions/poker/highHand/HighHandPageContent";

/**
 * Payload Live Preview iframe target for `high-hand-promotions`.
 * Always enabled (`forceEnabled`) so CMS editors see drafts without the
 * `high-hand` feature flag.
 */
const HighHandPreview = () => {
  const { t, i18n } = useTranslation();
  const { card: page, isLoading } = useHubCardLivePreview(
    "high-hand",
    {
      depth: 2,
      mapDoc: mapHighHandDoc,
      requestHandler: highHandLivePreviewRequestHandler,
      forceEnabled: true,
    },
    i18n.language,
  );

  if (isLoading) {
    return (
      <PreviewStatus>
        <Spinner animation="border" variant="light" role="status">
          <span className="visually-hidden">{t("loading")}</span>
        </Spinner>
      </PreviewStatus>
    );
  }

  if (!isMeaningfulHighHandPage(page)) {
    return (
      <PreviewStatus>
        <p>{t("poker.highHand.preview.waitingForDocument")}</p>
      </PreviewStatus>
    );
  }

  return (
    <PreviewShell>
      <HighHandPageContent page={page} forceShowCashPrizes />
    </PreviewShell>
  );
};

const PreviewStatus = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--black);
  color: var(--mutedwhite);
  text-align: center;
  padding: 2rem;
`;

/** Live Preview has no site navbar — drop Hero's navbar clearance offset. */
const PreviewShell = styled.div`
  .hero_container {
    margin-top: 0 !important;
    padding-top: 0 !important;
  }
`;

export default HighHandPreview;
